export const PartFinancialValidation = (formData) => {
    const errors = {};
  
    // Validate each field
    debugger;
    if (!formData.PurchaseNominal) {
      errors.PurchaseNominal = 'This field is required';
    }
    if (!formData.SaleNominal) {
        errors.SaleNominal = 'This field is required';
      } 
  
    return errors;
  };
  
 